import * as luxon from 'luxon';
import Vue from 'vue';
import DocumentData = firebase.firestore.DocumentData;
import {MAFUser} from '@/store/User/types';
import {DateTime} from 'luxon';
import {baseClass} from '@/store/types';
import * as firebase from 'firebase';
import DocumentReference = firebase.firestore.DocumentReference;
import DocumentSnapshot = firebase.firestore.DocumentSnapshot;
import Timestamp = firebase.firestore.Timestamp;
import {PlaceDetailsResult} from '@google/maps';

// TODO: fix max-classes-per-file
/* tslint:disable:max-classes-per-file */

export interface RateState {
    reviewRate: ReviewRate[] | undefined;
    commentsQues: CommentQue[] | undefined;
    faqs: FAQ[] | undefined;
}

export class ReviewRate {
    get user_name(): string {
        if (this.User && this.User.name) {
            return this.User.name;
        }
        return '';
    }
    get user_type(): string {
        if (this.User && this.User.userType) {
            return this.User.userType;
        }
        return '';
    }
    get user_email(): string {
        if (this.User && this.User.email) {
            return this.User.email;
        }
        return '';
    }
    get user_avatar(): string {
        if (this.User && this.User.avataarUrl) {
            return this.User.avataarUrl;
        }
        if (this.User && this.User.imageURL) {
            return this.User.imageURL;
        }
        if (this.User) {
            const BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
            return this.User.getAvataarUrl(BASE_URL, true);
        }
        return '';
    }
    public rate: number = 0;
    public review: string = '';
    public userRef: DocumentReference | undefined;
    public userId: string = '';
    public date: Date | string | undefined;
    public User: MAFUser|undefined;
    constructor(payload: ReviewRate | null | DocumentData | undefined) {
        if (payload) {
            this.rate = payload.rate;
            this.review = payload.review;
            this.userRef = payload.userRef;
            this.userId = payload.userId;
            this.date = baseClass.convertToJSDate(payload.date);
        }
    }

    public toPlainObj(): object {
        return {
            rate: this.rate,
            review: this.review,
            date: this.date instanceof Date ? Timestamp.fromDate(this.date) : this.date,
            userRef: this.userRef,
            userId: this.userId,
        };
    }
    public getUser() {
        const self = this;
        return new Promise(((resolve) => {
            if (self.userRef) {
                self.userRef.get().then((doc) => {
                    this.User = new MAFUser(doc.data()); // Set MAFUser to User
                    resolve();
                });
            } else {
                resolve();
            }
        }));
    }
}
export class FAQ {
    public static returnFAQList(payload: DocumentSnapshot ): FAQ[] {

        const ret: FAQ[] = [];
        if (payload.exists && payload.data() ) {
            const values = payload.data();
            if (values) {
                values.values.forEach((value: FAQ) => {
                    ret.push(new FAQ(value));
                });
            }
        }
        return ret;
    }
    public answer: string = '';
    public question: string = '';

    constructor(payload: FAQ | DocumentData | null | undefined ) {
        if (payload) {
            this.answer = payload.answer;
            this.question = payload.question;
        }
    }
}

export class CommentQue extends baseClass {
    get user_name(): string {
        if (this.User && this.User.name) {
            return this.User.name;
        }
        return '';
    }
    get user_type(): string {
        if (this.User && this.User.userType) {
            return this.User.userType;
        }
        return '';
    }
    get user_email(): string {
        if (this.User && this.User.email) {
            return this.User.email;
        }
        return '';
    }
    get user_avatar(): string |undefined {
        if (this.User && this.User.avataarUrl) {
            return this.User.avataarUrl;
        }
        if (this.User && this.User.imageURL) {
            return this.User.imageURL;
        }
        if (this.User) {
        const BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
        return this.User.getAvataarUrl(BASE_URL, true);
        }
        return '';
    }
    public Reference: DocumentReference | undefined;
    public comment: string = '';
    public date: Date | string | undefined;
    public userRef: DocumentReference | undefined;
    public User: MAFUser |undefined;
    public resolved: boolean|undefined = false;
    constructor(payload: CommentQue | DocumentData | null | undefined) {
        super();
        if (payload) {
            this.comment = payload.comment;
            this.userRef = payload.userRef;
            this.date = baseClass.convertToJSDate(payload.date);
            this.resolved = payload.resolved;
        }
    }
    public setDocumentReference(doc: DocumentReference) {
        this.Reference = doc;
    }
    public toPlainObj(): object {
        return {
            comment: this.comment,
            date: this.date instanceof Date ? Timestamp.fromDate(this.date) : this.date,
            userRef: this.userRef,
            resolved: this.resolved,
        };
    }
    public getUser() {
        const self = this;
        return new Promise(((resolve) => {
            if (self.userRef) {
                self.userRef.get().then((doc) => {
                    this.User = new MAFUser(doc.data()); // Set MAFUser to User
                    resolve();
                });
            } else {
                resolve();
            }
        }));
    }
}

